import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import './App.css';

import DataService from '../services/dataService';
import Sidepanel from './Sidepanel/Sidepanel';
import Loader from './Loader/Loader';
import OptimizationResult from './OptimizationResult/OptimizationResult';
import Map from './Map';
import optimizationService from '../services/optimizationService';
import stopService from '../services/stopService';

class App extends React.Component {
  // TODO: add behavior between Map and Sidepanel

  constructor(props) {
    super(props);
    this.state = {
      // This is the data which is going to be updated
      data: {
        totalStops: DataService.totalStops,
        totalDistance: DataService.totalDistance,
        routes: DataService.getRoutes(),
        stops: DataService.getStops(),
      },
      currentPage: 'home',
      selectedRoute: null,
      selectedStop: null,
      stopsToOptimize: {},
      editMode: false,
      isOptimizing: false,
      isBackdropOpened: false,
      optimizationResult: null,
      highlightedRoute: null,
    };
  }
  handleRouteSelected = item => {
    this.setState({
      selectedRoute: item,
      selectedStop: null,
      highlightedRoute: null,
      currentPage: item ? 'route' : 'home',
    });
  };

  handleOptimization = () => {
    console.log('stops to optimise', this.state.stopsToOptimize);
    this.setState(
      {
        isBackdropOpened: true,
        isOptimizing: true,
      },

      async () => {
        // rearrange all routes
        const requestInput = optimizationService.prepareInput(
          this.state.stopsToOptimize,
          this.state.data.routes
        );

        let results = await Promise.all(
          requestInput.map(async route => {
            return await optimizationService.optimizeRoute(route);
          })
        );

        this.setState({
          isOptimizing: false,
          optimizationResult: [...results],
        });

        // fire directions service
        // set new route state
      }
    );
  };

  toggleEditMode = () => {
    this.setState({
      editMode: !this.state.editMode,
      stopsToOptimize: {},
    });
  };

  updateRoutes = () => {
    // TODO: update stops state;
    const routeResults = this.state.optimizationResult;
    const newRoutes = this.state.data.routes.map(route => {
      const routeMatch = routeResults.find(item => item.id === route.id);
      return routeMatch ? routeMatch : route;
    });
    this.setState({
      editMode: false,
      data: {
        routes: newRoutes,
        stops: DataService.getStops(newRoutes),
        totalDistance: newRoutes.reduce((acc, item) => acc + item.distance, 0),
      },
      stopsToOptimize: {},
      optimizationResult: null,
      isBackdropOpened: false,
    });
  };

  rejectOptimization = () => {
    this.setState({
      optimizationResult: null,
      isBackdropOpened: false,
      editMode: false,
      stopsToOptimize: {},
    });
  };

  resetOptimizationResult = () => {
    this.setState({
      optimizationResult: null,
      isBackdropOpened: false,
    });
  };

  selectStop = stopId => {
    if (this.state.editMode) {
      stopId && this.updateSelectedStops(stopId);
    } else {
      // even if we are in edit mode, we must have route sidebar open to see unstaged stop changes
      const stop = this.state.data.stops.find(item => item.id == stopId);
      const routeId =
        stop && this.state.selectedRoute != stop.route_id
          ? stop.route_id
          : stop
          ? this.state.selectedRoute
          : null;

      this.handleRouteSelected(routeId);

      this.setState({
        selectedStop: stopId,
      });
    }
  };

  removeStopFromSelected = stopId => {
    const stopsToOptimize = stopService.removeStop(
      stopId,
      this.state.stopsToOptimize
    );
    this.setState({
      stopsToOptimize: stopsToOptimize,
    });
  };

  updateSelectedStops = stopId => {
    const stopsToOptimize = stopService.updateSelectedStops(
      stopId,
      this.state.stopsToOptimize,
      this.state.data.stops
    );

    this.setState({
      stopsToOptimize: stopsToOptimize,
    });
    // even if we are in edit mode, we must have route sidebar open to see unstaged stop changes
    // if it's a click to select a new route - do not change selected route
    const stop = this.state.data.stops.find(item => item.id == stopId);
    if (
      this.state.selectedRoute != stop.route_id &&
      stopService.isNewStopAdded()
    ) {
      this.handleRouteSelected(stop.route_id);
    }
  };

  highlightRoute = routeId => {
    this.setState({
      highlightedRoute: routeId,
    });
  };

  render() {
    const {
      data,
      isBackdropOpened,
      isOptimizing,
      optimizationResult,
      selectedRoute,
      stopsToOptimize,
      editMode,
      selectedStop,
      highlightedRoute,
    } = this.state;

    return (
      <>
        <Backdrop className="backdrop" open={isBackdropOpened}>
          {isOptimizing && <Loader />}
          {!isOptimizing && !!optimizationResult && (
            <OptimizationResult
              data={optimizationResult}
              originData={data.routes}
              onConfirm={this.updateRoutes}
              onReject={this.rejectOptimization}
              onClose={this.resetOptimizationResult}
            />
          )}
        </Backdrop>
        <div className="flex flex-row">
          <Sidepanel
            activeItem={this.state.currentPage}
            selected={selectedRoute}
            selectedStop={selectedStop}
            onSelect={this.handleRouteSelected}
            onOptimize={this.handleOptimization}
            data={data}
            stopsToOptimize={stopsToOptimize}
            editMode={editMode}
            onEditModeChange={this.toggleEditMode}
            onStopClick={this.selectStop}
            onStopRemove={this.removeStopFromSelected}
            highlightedRoute={highlightedRoute}
            onRouteHover={this.highlightRoute}
          />
          <Map
            onSelectRoute={this.handleRouteSelected}
            stops={data.stops}
            routes={data.routes}
            selectedRoute={selectedRoute}
            stopsToOptimize={stopsToOptimize}
            editMode={editMode}
            selectedStop={selectedStop}
            onStopClick={this.selectStop}
            onSelectedStopsUpdate={this.updateSelectedStops}
            highlightedRoute={highlightedRoute}
            onRouteHover={this.highlightRoute}
          />
        </div>
      </>
    );
  }
}

export default App;
